import React from 'react';
import './Benefit.scss';

/**
 * renders a benefit component
 * @param {string} title
 * @param {string} description
 * @returns {JSX.Element}
 * @constructor
 */
const Benefit = ({ title, description }) => (
  <div className="c-benefit">
    <div className="c-benefit__title h4-roobert">
      <h4>{title}</h4>
    </div>
    <div className="c-benefit__description body-2">
      <p>{description}</p>
    </div>
  </div>
);

export default Benefit;
